import React from 'react';
import classNames from '../classnames/bind';
import styles from './index.css';
import PropTypes from 'prop-types';
import defaultAvatar from './default_avatar.png';

const cx = classNames.bind(styles);

/**
 *
 * @param {String} [size=normal] - 头像尺寸
 * @param {String} src - 头像地址
 * @param {String} [shape=circle] - shape 头像形状
 * @returns
 * @author 陈傲胜
 */

const Avatar = ({ noSize = false, size = 'normal', src = defaultAvatar, shape = 'circle' }) => {
    if (noSize) size = 'no_size';
    const rootClass = cx('avatar', size, {
        circle: shape === 'circle',
    });

    return (
        <span className={rootClass}>
            <span className={cx('avatar-img')} style={{ backgroundImage: `url(${src}), url(${defaultAvatar})` }} />
        </span>
    );
};

Avatar.propTypes = {
    /**
     * 可选值为’large'=88x88|'normal'=64x64|'small'='48x48'
     */
    size: PropTypes.string,
    /**
     * 不需要内置尺寸
     */
    noSize: PropTypes.bool,
    /**
     * 头像照片地址
     */
    src: PropTypes.string,
    /**
     * 头像展示形状，默认为circle，可以选择square，方形
     */
    shape: PropTypes.string,
};

export default Avatar;
